import { Locale, type LocalizedString } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export const categoryPathMap: LocalizedString = {
	[Locale.cs]: "/katalog-kromschroder",
	[Locale.en]: "/catalogue-kromschrooder",
	[Locale.sk]: "/katalog-kromschroder",
};

export function getCataloguePath(locale: Locale): string {
	return getPathInLocale(locale, categoryPathMap);
}
